import React, { useEffect, useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
} from '@mui/material';
import Spinner from '~/components/Spinner/Spinner';
import axios from 'axios';

import { fetchUnreadTextMessages, markMessageAsRead, removePhoneFromOutreach } from '../services/api';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { components } from 'react-select';
import { toast } from 'react-toastify';
import '../containers/ContentModerationContainer/style.css'; // Import styles

const AllTexts: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [messages, setMessages] = useState<any[]>([]);

  const viewTextsExternally = () => {
    window.open('https://spa.eztexting.com/dashboard', '_blank')
  }

  const removeFromOutreach = async (id: string, contactNumber: string) => {
    const postFields = {
      idList: [id],
      contactNumber: contactNumber
    };


    try {
      const response = await removePhoneFromOutreach(postFields);
      
      //setMessages(messages.filter(msg => msg.id !== id));
      toast.success('Removed from future outreach');
  
    } catch (error) {
      console.error('Error removing from outreach:', error);
    }    
    
  }

  const markAsRead = async (id: string, note: string, contactNumber: string) => {
    const postFields = {
      idList: [id],
      extraMessage: note,
      contactNumber: contactNumber
    };
  
    try {
      const response = await markMessageAsRead(postFields);
      
      setMessages(messages.filter(msg => msg.id !== id));
      toast.success('Marked as read');
  
    } catch (error) {
      console.error('Error marking messages as read:', error);
    }
  }

  // Define handleNoteChange function HERE
  const handleNoteChange = (messageId: string, newValue: string ) => {
    setMessages((prevMessages) =>
      prevMessages.map((msg) =>
        msg.id === messageId ? { ...msg, note: newValue } : msg
      )
    );
  };

  useEffect(() => {
    const loadMessages = async () => {
      try {
        setLoading(true);
        const data = await fetchUnreadTextMessages();
        console.log(data.data.content);
        setMessages(data.data.content);
      } catch (error) {
        console.error('Failed to load messages:', error);
      } finally {
        setLoading(false);
      }
    };

    loadMessages();
  }, []);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <Spinner />
      </Box>
    );
  }

  return (
    <Box sx={{ padding: 3 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        All Unread Text Messages
      </Typography>
      
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ width: '200px', whiteSpace: 'nowrap' }}>From</TableCell>
              <TableCell>Message</TableCell>
              <TableCell sx={{ width: '180px', whiteSpace: 'nowrap' }}>Received At</TableCell>
              <TableCell colSpan={2} sx={{ width: '280px', whiteSpace: 'nowrap' }}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {messages.map((message) => (
              <TableRow key={message.id}>
                <TableCell sx={{ width: '200px', whiteSpace: 'nowrap' }}>
                  {message.contactNumber} 
                  <button 
                    className='btn-standard btn-secondary right-left'  
                    onClick={() => removeFromOutreach(message.id, message.contactNumber)}
                  >
                    Remove From Outreach
                  </button>
                </TableCell>
                <TableCell sx={{ wordBreak: 'break-word' }}>{message.message}</TableCell>
                <TableCell sx={{ width: '180px', whiteSpace: 'nowrap' }}>{new Date(message.sentAt).toLocaleString()}</TableCell>
                <TableCell sx={{ width: '150px', whiteSpace: 'nowrap' }}>
                  <TextField
                    size="small"
                    variant="outlined"
                    placeholder="Add note"
                    // Add type for event 'e'
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleNoteChange(message.id, e.target.value)}
                    value={message.note || ''}
                    fullWidth
                  />
                </TableCell>

                <TableCell sx={{ width: '130px', whiteSpace: 'nowrap' }}>
                  <button 
                    className='btn-standard btn-secondary right-margin'  
                    onClick={() => markAsRead(message.id, message.note, message.contactNumber)}
                  >
                    Send &amp; Mark as Read
                  </button>

                  <button 
                    className='btn-standard btn-primary' 
                    onClick={() => viewTextsExternally()}
                  >
                    View
                  </button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default AllTexts; 